import { useAppSelector } from 'hooks/reduxHooks'
import { getCorporateEventBasePath } from 'corporateEvents/utils/corporateEventsRoutes'

export default function useCorporateEventBasePath(eventId: string, regionCode: string): string {
  const hostname = useAppSelector(state => state.system.hostname)
  return getCorporateEventBasePath(eventId, regionCode, hostname)
}
